const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    return 100;
  }

  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

/* CollexyLux mobile collection UX hotfix v2.8
   - Search-result cards cloned after page load must not remain in Dawn's hidden
     scroll-animation state.
   - On iOS, a visible Set result can be selected with the first tap while the
     Set search keyboard is still open. */
(() => {
  'use strict';
  if (window.CLXMobileCollectionHotfixV28) return;
  window.CLXMobileCollectionHotfixV28 = true;

  const revealClxSearchCards = (scope = document) => {
    const root = scope instanceof Element || scope instanceof Document ? scope : document;
    const lists = [];
    if (root.matches?.('#clx-search-product-grid')) lists.push(root);
    root.querySelectorAll?.('#clx-search-product-grid').forEach((list) => lists.push(list));

    lists.forEach((list) => {
      list.querySelectorAll('.scroll-trigger').forEach((element) => {
        element.classList.remove('scroll-trigger--offscreen');
        element.classList.add('scroll-trigger--cancel');
      });
    });
  };

  revealClxSearchCards(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) revealClxSearchCards(node);
      });
    });
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  const mobileSetSearchForRow = (row) => {
    if (!row || window.matchMedia('(min-width: 750px)').matches) return null;
    const details = row.closest('.mobile-facets__details.clx-set-search-facet');
    if (!details) return null;
    const search = details.querySelector('.clx-set-option-search');
    if (!search || !search.value.trim()) return null;
    return search;
  };

  document.addEventListener('touchend', (event) => {
    const row = event.target.closest?.('li.mobile-facets__item');
    const search = mobileSetSearchForRow(row);
    if (!search) return;

    const checkbox = row.querySelector('input.mobile-facets__checkbox:not(:disabled)');
    if (!checkbox) return;

    event.preventDefault();
    event.stopPropagation();
    search.blur();
    checkbox.click();
  }, { capture: true, passive: false });
})();
